import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import FaChevronLeft from 'react-icons/lib/fa/chevron-left';
import FaChevronRight from 'react-icons/lib/fa/chevron-right';

import { Button } from 'wanderu-components';
import {
    i18nMomentPropType,
    localize,
} from 'wanderu-i18n';

import styles from './MonthHeader.scss';

MonthHeader.propTypes = {
    currentMonth: i18nMomentPropType.isRequired,
    onMonthChange: PropTypes.func.isRequired,
    enablePreviousMonthButton: PropTypes.bool,
};

function MonthHeader({
    t, currentMonth, onMonthChange, enablePreviousMonthButton,
}) {
    function onPreviousMonthButtonClick() {
        if (!enablePreviousMonthButton) {
            return;
        }
        onMonthChange(-1);
    }

    function onNextMonthButtonClick() {
        onMonthChange(1);
    }

    return (
        <div className={styles.container}>
            <Button
                className={classNames(
                    styles.previous,
                    { [styles.inactive]: !enablePreviousMonthButton },
                )}
                label={t('previous-month')}
                onClick={onPreviousMonthButtonClick}
                unstyled
            >
                <FaChevronLeft />
            </Button>
            <span data-id="header-date">
                {`${currentMonth.format('MMMM')} ${currentMonth.format('YYYY')}`}
            </span>
            <Button
                className={styles.next}
                label={t('next-month')}
                onClick={onNextMonthButtonClick}
                unstyled
            >
                <FaChevronRight />
            </Button>
        </div>
    );
}

export { MonthHeader };
export default localize(MonthHeader, ['t'], 'baseApp');
